import { render, staticRenderFns } from "./FormTemplate.vue?vue&type=template&id=30664d47&scoped=true&"
import script from "./FormTemplate.vue?vue&type=script&lang=js&"
export * from "./FormTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplate.vue?vue&type=style&index=0&id=30664d47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30664d47",
  null
  
)

/* custom blocks */
import block0 from "./FormTemplate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports